<template>
    <div class="process-complete">
        <h2>{{ hebrew? 'תהליך עיבוד הקבצים הסתיים בהצלחה!': 'Files processed successfully' }}</h2>
        <span>{{hebrew? 'קישור לקובץ המעובד, ממתין לך בדוא״ל וגם כאן': 
        'A link to the processes file was emailed to you and appears below' }}</span>

        <div class="progress-wrap position-relative">
            <small class="position-absolute text-muted mt-n4" :style="{ right: value-8 + '%' }">{{ value }}%</small>
            <b-progress :value="value" :max="max">
            </b-progress>

        </div>
        <a class="download-link d-block bg-secondary py-1 px-2 m-auto text-decoration-none" :href="link">
            <small dir="ltr" class="overflow-hidden d-block"><i class="fas fa-link mr-1"></i> {{ link }}</small>
        </a>
    </div>
</template>
<script>
export default {
    name: "ProcessComplete",
    data() {
        return {
            value: 100,
            max: 100
        }
    },
    computed: {
        hebrew() {
            return this.$settings.hebrew
        },
        link() {
            return this.$store.state.uploadStatus.final_result_url
        }
    }
}
</script>
<style scoped lang="scss">
.download-link {
    border-radius: 4px;
    width: 270px;

    small {
        text-overflow: ellipsis;
        white-space: nowrap;

    }
}
</style>    